<template>
    <div class="lms__superadmin_workspaces_add">
        <div class="lms__superadmin_workspaces_add_header">
            <view-actions
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: 'Workspaces',
                        to: { name: 'lms-superadmin-workspace-list' }
                    }
                ]"
                :cancel-button-text="user.isSuperadmin() || user.isMasterAdministrator() ? 'Discard' : 'Go back'"
                :cancel-notify-active="true"
                :cancel-notify-content-text="'This action will remove all changes. Continue?'"
                :cancel-notify-submit-text="'Discard'"
                :notify-title="'workspace'"
                :notify-process="'stop adding'"
                :submit-button-active="user.isSuperadmin() || user.isMasterAdministrator() ? true : false"
                :submit-button-text="'Create'"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-event-name="'workspace-create'"
                :title="'New workspace'"
                @emit-notify-cancel-submit="workspaceStopAdd"
                @emit-submit="performSubmitValidate"
            />
        </div>
        <div class="lms__superadmin_workspaces_add_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar :nav-items="sidebarNav"></component-sidebar>
                    </div>
                    <div class="column p-t-b-0">
                        <section class="lms__superadmin_workspaces_add_main_content">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import PopNotify from '@/components/default/shared/PopNotify'
import { validateBeforeRouteLeave, performSubmitValidate } from '@/helpers/mixins'
import { User } from '@/User'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'

export default {
  name: 'lms-superadmin-workspace-add',
  components: { ComponentSidebar, PopNotify, ViewActions },
  mixins: [validateBeforeRouteLeave, performSubmitValidate],
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    rootItemName () {
      return 'workspace'
    },
    nameActionCreate () {
      return 'lmsSuperadminWorkspaceCreate'
    },
    nameActionUpdate () {
      return 'lmsSuperadminWorkspaceUpdate'
    },
    nameActionReset () {
      return 'lmsSuperadminWorkspaceReset'
    },
    sidebarNav () {
      let navArr = []

      navArr.push({ label: 'Details', name: 'lms-superadmin-workspace-add-details' })
      navArr.push({ label: 'Appearance', name: 'lms-superadmin-workspace-add-appearance' })
      navArr.push({ label: 'Onboarding text', name: 'lms-superadmin-workspace-add-onboarding' })
      navArr.push({ label: 'Footer', name: 'lms-superadmin-workspace-add-footer' })
      navArr.push({ label: 'User fields', name: 'lms-superadmin-workspace-add-custom-fields' })
      if (this.user.isMasterAdministrator()) {
        navArr.push({ label: 'Sign-up and authentication', name: 'lms-superadmin-workspace-add-self-registration' })
        navArr.push({ label: 'Feedback forms', name: 'lms-superadmin-workspace-add-feedback-forms' })
      }
      navArr.push({ label: 'Certificates', name: 'lms-superadmin-workspace-add-certificates' })

      return navArr
    }
  },
  methods: {
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-workspace-create')
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-workspace-create')
    },
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('workspace-submit')
    },
    //
    workspaceStopAdd () {
      this.allowRedirectBeforeRouteLeave()
      const routeQuery = this.$route.query
      if (routeQuery.customerId) {
        this.$router.push({ name: 'lms-superadmin-customer-edit-workspaces', params: { id: routeQuery.customerId } })
      } else {
        this.$router.push({ name: 'lms-superadmin-workspace-list' })
      }
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/workspaces/_lmssuperadminworkspacesaddedit.scss";
</style>
